import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ffa1240")

_pushScopeId("data-v-2ffa1240")
const _hoisted_1 = { class: "w-full tracking-height overflow-y-auto pb-8 relative" }
const _hoisted_2 = { class: "w-full mt-8 flex flex-row justify-between items-center" }
const _hoisted_3 = { class: "flex items-center gap-x-3" }
const _hoisted_4 = { class: "w-350px" }
const _hoisted_5 = {
  key: 2,
  class: "w-full flex flex-col pt-8"
}
const _hoisted_6 = {
  key: 3,
  class: "flex flex-col mt-8 gap-y-5"
}
const _hoisted_7 = { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: "border border-gray-lp-400 shadow-sm rounded-xl p-5 overflow-y-auto"
}
const _hoisted_9 = { class: "grid grid-cols-2 gap-y-5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }, " Partner Log Hydra ", -1)
const _hoisted_11 = { class: "col-span-2 text-black-lp-300 table" }
const _hoisted_12 = {
  key: 1,
  class: "border border-gray-lp-400 shadow-sm rounded-xl p-5 overflow-y-auto"
}
const _hoisted_13 = { class: "grid grid-cols-2 gap-y-5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "col-span-2 text-black-lp-300 text-20px font-semibold" }, " Partner Log Gober ", -1)
const _hoisted_15 = { class: "col-span-2 text-black-lp-300 table" }
const _hoisted_16 = {
  key: 4,
  class: "flex flex-row gap-x-3 absolute border border-gray-lp-400 shadow-md p-4 rounded-md items-start bg-white",
  style: {"top":"6rem","right":"2px"}
}
const _hoisted_17 = { class: "flex flex-col gap-y-2 text-14px max-w-xs" }
const _hoisted_18 = { class: "text-black-lp-300 font-semibold" }
const _hoisted_19 = { class: "text-gray-lp-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_lp_input, {
            placeholder: "Cari No. STT",
            modelValue: _ctx.sttNo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNo = $event)),
            onChange: _ctx.handleError,
            onEnter: _ctx.trackStt,
            error: _ctx.isError,
            disabled: false,
            errorIcon: false
          }, null, 8, ["modelValue", "onChange", "onEnter", "error"])
        ]),
        _createVNode(_component_lp_button, {
          disabled: !_ctx.sttNo,
          title: "Cari",
          textColor: "white",
          onClick: _ctx.trackStt
        }, null, 8, ["disabled", "onClick"])
      ])
    ]),
    (!_ctx.isLoading && !_ctx.showSttDetail && !_ctx.isError)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 0,
          data: "data STT"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          errorType: _ctx.errorCause,
          errorImage: _ctx.alertMessage.image,
          errorTitle: _ctx.alertMessage.title,
          errorMessage: _ctx.alertMessage.message
        }, null, 8, ["errorType", "errorImage", "errorTitle", "errorMessage"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_skeleton, {
            width: "600px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-10",
            width: "800px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "700px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "500px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "800px",
            height: "20px"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, " STT: " + _toDisplayString(_ctx.logStt.sttNo), 1),
          (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_TableV2, {
                      style: {"margin-top":"0"},
                      columns: _ctx.columns,
                      data: _ctx.logStt.partnerlogHydra,
                      pagination: _ctx.pagination,
                      hidePagination: ""
                    }, null, 8, ["columns", "data", "pagination"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showSttDetail && !_ctx.isLoading && !_ctx.isError)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_TableV2, {
                      style: {"margin-top":"0"},
                      columns: _ctx.columns,
                      data: _ctx.logStt.partnerlogGober,
                      pagination: _ctx.pagination,
                      hidePagination: ""
                    }, null, 8, ["columns", "data", "pagination"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowAlertMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("img", {
            src: require('@/app/ui/assets/svg/exclamation-yellow.svg'),
            class: "w-6 max-w-none",
            alt: "warning"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.alertMessage.title), 1),
            _withDirectives(_createVNode("p", _hoisted_19, null, 512), [
              [_directive_sanitize_html, _ctx.alertMessage.message]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})